<template>
<div class="chapter">
<div class="inner_page">
<p class="authornote">As usual, I have relied upon dozens of professionals for the expertise, anecdotes, and cop talk that inspired this story. Special thanks goes to Criminal Investigator Donna Blake and Deputy D.A. Mike Carleton, San Diego County District Attorney’s Office; Security Director Roger Warburton and Detective Michael Newell, Naval Air Station, North Island; HazMat Specialist Nick Vent, San Diego County Environmental Health Services; Senior Investigator Barbara Naimark, State of California Health Services; Special Agent Gabrielle Carruth, Naval Investigative Service; Sergeant Bill Wolf, Office of Emergency Management, San Diego Police Department; and Private Investigator Manuel Smith, of the U.S.-Mexican border.</p>
<p class="authornote-1">And many thanks to Dick and Janene Gant of the San Diego Yacht Club for the local lore and color.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// author.vue?7d6b7534